<script setup>
import { onMounted, ref } from 'vue';
import { useCommonStore } from '@/stores/common';

// CloudFront URL for assets
const store = useCommonStore();
const imgURL = ref(store.cloudfrontImgURL);
const pdfURL = ref(store.cloudfrontPdfURL);
// Footer PDF Links
const ethicsLink = ref(pdfURL.value+'ethics.pdf');
const complaintsLink = ref(pdfURL.value+'complaints.pdf');
const privacyLink = ref(pdfURL.value+'privacycookiespolicy.pdf');
const termsLink = ref(pdfURL.value+'termsofbusiness.pdf');
const feesLink = ref(pdfURL.value+'feeschedule.pdf');

const copyrightToYear = ref('2003');

function setCopyrightYear() {
    const d = new Date();
    copyrightToYear.value = d.getFullYear();
}

function setVouchedFor() {
    (function (){var http = new XMLHttpRequest();http.onreadystatechange = function(){if (this.readyState === 4 && this.status === 200){document.getElementById("vf_widget_stars_centre_panel_dark_firm_12170").innerHTML = http.responseText;}};http.open("GET", "https://api.vouchedfor.co.uk/v2/public/firm/12170/widget?type=stars_centre_panel_dark&version=vf2023", true);http.send();}());
}

// Google preferred source button - publisher.js scans the DOM when it loads, so it must be
// injected after the footer has mounted, otherwise the button placeholder doesn't exist yet
function setGooglePreferredSource() {
    if (document.getElementById('google-preferred-source-script')) return;
    const script = document.createElement('script');
    script.id = 'google-preferred-source-script';
    script.async = true;
    script.src = 'https://news.google.com/swg/js/v1/publisher.js';
    document.head.appendChild(script);
}

onMounted(() => {
    setCopyrightYear();
    setVouchedFor();
    setGooglePreferredSource();
});
</script>

<template>
    <footer>
        <div class="clarity-footer">
            <div class="flex flex-wrap justify-center clarity-footer-logos gap-4">
                <img :src="imgURL+'footer-logos/chartered-planners-footer-logo.png'" alt="Chartered Planners Logo">
                <img class="clarity-footer-logos-img" :src="imgURL+'footer-logos/citywire-clarity-2024.png'" alt="CityWire Top 100 Logo">
                <img class="clarity-footer-logos-img" :src="imgURL+'footer-logos/ft-adviser-clarity-2024.png'" alt="FT Adviser Logo">
                <img class="clarity-footer-logos-img" :src="imgURL+'footer-logos/iso270012022footerlogo.png'" alt="ISO27001 Logo">
                <div class="vf_firm_widget">
                    <div id="vf_widget_stars_centre_panel_dark_firm_12170"></div>
                </div> 
                <div google-add-preferred-source-btn data-lang="en"></div>
            </div>
            <div class="clarity-small-grey-text">
                <p>© 2003 - {{ copyrightToYear }} clarity Ltd. clarity is authorised and regulated by the Financial Conduct Authority (185468). VAT No 164 1741 18. Reg No in England and Wales: 3466459</p>
                <a :href="ethicsLink" target="_blank" onclick="gtag('event','download_pdf',{'file_name':'ethics.pdf'});">Ethics</a> | 
                <a :href="complaintsLink" target="_blank" onclick="gtag('event','download_pdf',{'file_name':'complaints.pdf'});">Complaints</a> | 
                <a href="https://www.fca.org.uk/scamsmart" target="_blank">ScamSmart</a> | 
                <a href="/privacy-policy">Privacy & Cookies</a> | 
                <a :href="termsLink" target="_blank" onclick="gtag('event','download_pdf',{'file_name':'termsofbusiness.pdf'});">Terms of Business</a> | 
                <a :href="feesLink" target="_blank" onclick="gtag('event','download_pdf',{'file_name':'feeschedule.pdf'});">Fees</a>
            </div>
            <div class="flex justify-center clarity-footer-social">
                <a href="https://www.youtube.com/@clarityltd" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/youtube-icon-active.png'" alt="YouTube Logo"></a>
                <a href="https://www.instagram.com/clarity_global/" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/instagram-icon-active.png'" alt="Instagram Logo"></a>
                <a href="https://www.linkedin.com/company/clarityltd" target="_blank"><img class="clarity-margin-right-2xs" :src="imgURL+'social-media/linkedin-icon-active.png'" alt="Linkedin Logo"></a>
                <a href="https://www.facebook.com/claritygloballtd" target="_blank"><img :src="imgURL+'social-media/facebook-icon-active.png'" alt="Facebook Logo"></a>
            </div>
        </div>
    </footer>
</template>

<style lang="css" scoped>
    footer {
        margin-top: 60px;
    }
    .clarity-footer {
        text-align: center;
        padding-left: 20px;
        padding-right: 20px;
    }
    .clarity-footer p {
        padding: 0;
        margin: 0;
        text-align: center;
    }
    .clarity-footer a {
        text-decoration: underline!important;
    }
    .clarity-footer a:visited {
        color: var(--clarity-grey);
        text-decoration: underline;
    }
    .clarity-footer-logos {
        margin-bottom: 25px;
    }
    .clarity-footer-logos img {
            height: 100px;
            width: auto;
        }
    .clarity-footer-logos-img {
         /* margin-left: 30px; */
    }
    .clarity-footer-social img {
        width: 20px;
        height: auto;
        margin-top: 25px;
        margin-bottom: 60px;
    }
    .clarity-footer-social a {
        color: var(--clarity-grey);
        text-decoration: none!important;
    }
    :deep(.vf-pcd__content) {
        padding: 0px !important;
        min-width: 0px;
        min-height: 0px;
    }
    :deep(.vf-pcd) {
        min-width: 0px;
    }
    /* Default Big Screen 1920px */
    /* Mid Screen */
    @media only screen and (max-width: 1366px) {
        .clarity-footer-logos img {
            height: 90px;
            width: auto;
        }
    }
    /* Small Screen */
    @media only screen and (max-width: 1024px) {}
    @media only screen and (max-width: 912px) {}
    /* Tablet */
    @media only screen and (max-width: 767px) {
        .clarity-footer-logos img {
            height: 80px;
            width: auto;
            margin-top: 30px;
        }
        :deep(.vf-pcd__content) {
            margin-top: 20px;
        }
    }
    /* Mobile */
    @media only screen and (max-width: 375px) {}
</style>